export const TAUTAN_RESERVASI = null;

export const FOTO = {
  src: "/images/telemedicin.png",
  alt: {
    id: "Poster layanan Telemedicine RS Jakarta Medical Center.",
    en: "Telemedicine service poster of Jakarta Medical Center Hospital.",
  },
};

export const TELEMEDICINE = {
  telepon: [
    {
      label: { id: "Customer Service", en: "Customer Service" },
      tampil: "0811-901-874",
      tel: "+62811901874",
      wa: "62811901874",
      pesanWa: {
        id: "Halo RS Jakarta Medical Center,\n\nSaya ingin melakukan reservasi layanan Telemedicine.\n\nMohon informasi jadwal dokter dan ketentuannya. Terima kasih.",
        en: "Hello RS Jakarta Medical Center,\n\nI would like to book a telemedicine consultation.\n\nPlease let me know the doctor's schedule and requirements. Thank you.",
      },
      utama: true,
    },
    {
      label: { id: "Hunting", en: "Main line" },
      tampil: "(021) 798 0888",
      tel: "+62217980888",
      utama: false,
    },
  ],
};


export const KETENTUAN = [];

export const LANGKAH = [
  {
    judul: { id: "Hubungi Customer Service", en: "Contact Customer Service" },
    isi: {
      id: "Sampaikan keluhan Anda dan tanyakan jadwal dokter yang tersedia.",
      en: "Describe your symptoms and ask which doctors are available.",
    },
  },
  {
    judul: { id: "Tentukan jadwal", en: "Choose a time" },
    isi: {
      id: "Petugas mengonfirmasi jadwal konsultasi beserta ketentuan dan biayanya.",
      en: "Our staff will confirm your consultation time, the requirements, and the cost.",
    },
  },
  {
    judul: { id: "Konsultasi daring", en: "Online consultation" },
    isi: {
      id: "Dokter menghubungi Anda pada waktu yang telah disepakati.",
      en: "The doctor will contact you at the agreed time.",
    },
  },
  {
    judul: { id: "Resep dan obat", en: "Prescription and medicines" },
    isi: {
      id: "Apabila diperlukan, dokter menerbitkan resep. Obatnya dapat ditebus di Apotek RS JMC atau diantar ke alamat Anda.",
      en: "If needed, the doctor will issue a prescription. Your medicines can be collected at the JMC pharmacy or delivered to your address.",
    },
  },
];
export const TAUTKAN_DELIVERY = true;
